import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { InjectAuthInterceptor } from '@modules/interceptors/inject-auth.interceptor';
import { SharedModule } from '@shared/shared.module';
import { PseComponent } from './modules/callbacks/pages/pse/pse.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import {MatCheckboxModule} from '@angular/material/checkbox';
@NgModule({ declarations: [
        AppComponent,
        PseComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        SharedModule,
        NgbModule,
        NoopAnimationsModule,
        MatCheckboxModule], providers: [
        CookieService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: InjectAuthInterceptor,
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
